//vue
import Vue from 'vue';
import VueRouter from 'vue-router';
//base
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';
//user
import UserIndex from '../views/user/Index.vue';
import UserList from '../views/user/List.vue';
import UserForm from '../views/user/Form.vue';
//permission
import PermissionIndex from '../views/permission/Index.vue';
import PermissionList from '../views/permission/List.vue';
import PermissionForm from '../views/permission/Form.vue';
//app
import AppIndex from '../views/app/Index.vue';
import AppList from '../views/app/List.vue';
import AppForm from '../views/app/Form.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: "/home"
  },
  {
    path: '/login',
    component: Login 
  },
  {
    path: '/home',
    component: Home
  },
  {
    path: '/user',
    component: UserIndex,
    children: [
      {
        path: "/",
        component: UserList
      },
      {
        path: ":id",
        component: UserForm
      }
    ]
  },
  {
    path: '/permission',
    component: PermissionIndex,
    children: [
      {
        path: "/",
        component: PermissionList
      },
      {
        path: ":id",
        component: PermissionForm
      }
    ]
  },
  {
    path: '/app',
    component: AppIndex,
    children: [
      {
        path: "/",
        component: AppList
      },
      {
        path: ":id",
        component: AppForm
      }
    ]
  }
];

const router = new VueRouter({
  routes
});

export default router;